/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */
import { IDomainModel } from './domain-model.interface';

import { PlanTypes } from './plan-type.domain';
export * from './plan-type.domain';

export const Lookups: IDomainModel[][] = new Array<IDomainModel[]>(
   PlanTypes,
);
